<template>
  <!--START WEBSITE-DESCRIPTION-->
  <section class="section section-lg bg-web-desc">
    <div class="bg-overlay"></div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="text-white">Pare de sonhar e realize!</h2>
          <p class="padding-t-15 home-desc">
            Adquira um de nossos planos e embarque nesta jornada de uma vez por
            todas.
          </p>
          <a
            href="#"
            class="btn btn-bg-white margin-t-30 waves-effect waves-light mb-5"
            >Veja nossos planos</a
          >
        </div>
      </div>
    </div>
    <div class="bg-pattern-effect">
      <img src="images/bg-pattern.png" alt="" />
    </div>
  </section>

  <!--END WEBSITE-DESCRIPTION-->
</template>

<script>
"use strict";
export default {
  name: "WebConfiguration",
  props: {}
};
</script>
